export default __webpack_public_path__ + "static/media/misc-closet2-1920w.e65e36a0.avif";